<template>
  <v-row>
    <v-col cols="12" class="px-0">
      <v-toolbar color="transparent" flat height="48">
        <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
          <router-link :to="{name: 'Components'}" class="subtitle-1 routerLink font-weight-medium">Componentes</router-link> <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon> Customer Base
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="4" v-if="$store.state.apps.retrieveLoader">
      <v-skeleton-loader type="article" />
    </v-col>

    <!-- feature landing page -->
    <template v-else-if="basesList && basesList.length === 0">
      <v-col cols="12">
        <v-sheet color="indigo darken-2 lighten-5" rounded="lg">
          <v-row class="pt-6 pl-6" align="start" justify="center">
            <v-col cols="7">
              <v-avatar color="white" size="48">
                <img :src="require('@/assets/appIcon-apps--CustomerBase.svg')" style="width:28px;height:28px;border-radius:0;" />
              </v-avatar>
              <span class="d-block mt-2 white--text text-h5 font-weight-medium">Permite a tus clientes administrar su suscripción</span>
              <span class="d-block mt-2 body-1 white--text font-weight-regular">Agrega funcionalidad de auto servicio de suscripción y facturación en tu sitio web o aplicación sin escribir código.</span>
              <v-btn class="mt-14" :to="{name: 'BaseCreate'}" color="primary">Comenzar</v-btn>
            </v-col>
            <v-col cols="5" class="pb-0">
              <v-carousel cycle hide-delimiters :show-arrows="false" height="300" interval="4000" vertical>
                <v-carousel-item v-for="(item, i) in demoImages" :key="i" :src="require(`@/assets/${item}.svg`)" />
              </v-carousel>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-col cols="8">
        <span class="d-block text--secondary subtitle-1 font-weight-medium">Beneficios y características</span>
        <v-divider />
        <v-row>
          <v-col>
            <img :src="require('@/assets/appAsset-ui--security.svg')" width="38" />
            <span class="d-block text--secondary subtitle-1 font-weight-medium">Autenticación segura</span>
            <span class="d-block mt-2 body-2">La información de tu cliente siempre está a salvo. Integra Customer Base con tu sistema de autenticación actual o utiliza la autenticación estándar de Piriod.</span>
          </v-col>
          <v-col>
            <img :src="require('@/assets/appAsset-ui--customize.svg')" width="38" />
            <span class="d-block text--secondary subtitle-1 font-weight-medium">En línea con tu marca</span>
            <span class="d-block mt-2 body-2">La información de tu cliente siempre está a salvo. Integra Customer Base con tu sistema de autenticación actual o utiliza la autenticación estándar de Piriod.</span>
          </v-col>
          <v-col>
            <img :src="require('@/assets/appAsset-ui--integration.svg')" width="38" />
            <span class="d-block text--secondary subtitle-1 font-weight-medium">Webhooks y Zapier</span>
            <span class="d-block mt-2 body-2">Extiende Customer Base conectándolo con miles de aplicaciones para automatizar tareas y diseñar una experiencia de auto atención perfecta para tu cliente.</span>
          </v-col>
        </v-row>
        <v-divider />
        <v-btn href="https://www.piriod.com/customer-base" target="_blank" color="primary" text :ripple="false">Más información<v-icon right small>mdi-open-in-new</v-icon></v-btn>
      </v-col>
      <v-col cols="4">
        <span class="d-block text--secondary subtitle-1 font-weight-medium">Tarifas</span>
        <v-divider />
        <v-list class="transparent">
          <v-list-item>
            <v-list-item-icon class="pt-2"><v-icon color="primary">mdi-puzzle</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">
                <template v-if="account.country.id === 'CL'">2.0 CLF</template>
                <template v-else>84.00 USD</template>
              </v-list-item-title>
              <v-list-item-subtitle class="text--primary">Adicionales a tu suscripción</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-btn @click="intercomNewMessage('Hola, necesito ayuda para iniciar con Piriod')" color="primary" text :ripple="false">Contactar a ventas<v-icon right small>mdi-chat</v-icon></v-btn>
        </v-list>
      </v-col>
    </template>
    <!-- end feature landing page -->

    <!-- content list  -->
    <template v-else>
      <v-col cols="4" v-for="d in basesList" :key="d.id">
        <v-card class="card-apps" :to="{name: 'BaseRetrieve', params: {id: d.id}}">
          <v-card-text class="py-10 px-0">
            <v-list class="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <img :src="require(`@/assets/appIcon-apps--CustomerBase.svg`)" width="24px">
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">{{d.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="card-apps background" :to="{name: 'BaseCreate'}" outlined>
          <v-card-text class="py-13 text-center subtitle-1 primary--text font-weight-medium">Crear un nuevo Customer Base</v-card-text>
        </v-card>
      </v-col>
    </template>
    <!-- end content list  -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    demoImages: [
      'appImage-customer-base--1',
      'appImage-customer-base--2',
      'appImage-customer-base--3'
    ]
  }),
  computed: mapState({
    basesList: state => state.apps.basesList
  }),
  methods: {
    getList () {
      this.$store.dispatch('apps/LIST', {
        resource: 'customer_base/bases'
      })
    }
  }
}
</script>
<style>
  .v-carousel {
    border-radius: 10px 0 11px 0;
  }
  .v-carousel .v-image__image--cover {
    background-position: top center !important;
  }
</style>